import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { setCurrentHomePage, setGoHome, setLoader, setOpenExternalLinkInSameTab } from "../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { getHotelList, getHotelListUpdatingProps } from "../../../action/hotelSelector";
import { currentWidget, setFailScreen, setHotelSelectionAfterLoginState, setShowCustomPopup } from "../../../action/action";
import { sendAnalytics } from "../../../action/homeAction";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
 
import { scrollToTop } from "../../../JS/scrollToTop";
import MiniLoader from "../../UI/MiniLoader";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { inAppBrowser } from "../../JS/inAppBrowser";
import { theKnowKeys } from "../../../config/layout2constant";
import { setCurrentTabNavItemList } from "../../action/action";
import { handleLocationSelect } from "../hotelSelector/hotelSelector";


const FindStayForTheNonKnowMembers = (props) => {

    const { t } = props;

    const [fetchHotelListAttempted, setFetchHotelListAttempted] = React.useState(false);
    const [hotelRegionData, setHotelRegionData] = React.useState([]);
    const [masterConnector, setMastorConnector] = React.useState({});


    const master_hotel_code = process.env.REACT_APP_CLIENT_CONFIG.replace("GJ_", "").toUpperCase();
    const current_hotel_code = (localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG || "").replace("GJ_", "").toUpperCase();


    const redirectToTheKnowTab =()=>{
            let TheKnowTab = props.footerTabList && props.footerTabList.find((item) => {
                return theKnowKeys.includes(item.uniqueKey.toLowerCase())
            });
    
            if (TheKnowTab) {
                props.setCurrentHomePage(TheKnowTab);
    
                console.log("props.footerTabList", TheKnowTab)
                props.widgetList.map((item) => {
                    if (item.uniqueKey === TheKnowTab.uniqueKey || item.uniqueKey === TheKnowTab.tabName.replace(/ /g, '').toLowerCase()) {
                        props.setCurrentTabNavItemList();
                        props.setCurrentTabNavItemList(item.widgets);
                    }
                })
                props.currentWidget({});
            }
        }
    


    // const handleOnClickHotel =(hotelData, proceedWithoutTheKnowLoginInApp)=>{
    //     console.log("sjflsfkls")
    //     if( String(hotelData.hotelName).toLowerCase()!="las vegas" &&  !proceedWithoutTheKnowLoginInApp && !props.externalSignIn.memberId){

    //          props.setShowCustomPopup(true,{
    //                   htmlTagId:"prompt-theknow-not-login-yet",
    //                   title:  t('hotelSelector.virginBookList.title'),    
    //                   subtitle:"",
    //                   heading:  t('hotelSelector.virginBookList.heading'),    
    //                   subHeading: t('hotelSelector.virginBookList.subHeading'),    
    //                   primaryButtonText: t('hotelSelector.virginBookList.primaryButtonText'),
    //                   secondaryButtonText:   t('hotelSelector.virginBookList.secondaryButtonText'),
    //                   secondaryButtonStyleIsUnderline:false,
    //                   primaryOnClick:()=>{ redirectToTheKnowTab(); props.setShowCustomPopup(false,{})},
    //                   closeOnClick:()=>{ props.setShowCustomPopup(false,{})},
    //                   secondaryOnClick:()=>{ console.log("dlslfjs"); handleOnClickHotel(hotelData,true);  props.setShowCustomPopup(false,{});}
    //               })   

    //         return;
    //     }
    //     inAppBrowser((  hotelData && hotelData.hotelMetaData && hotelData.hotelMetaData.bookingUrl )|| "https://virgin-hotels.80d-stage.com/nashville/reservations#/booking/step-1" , props, true, { displayName: "Book Virgin Stay", dontSetCurrentWidget: true })
    // }

    const handleSuccessResponse = (data) => {
        setHotelRegionData(data);
    }


    React.useEffect(() => {
        handleSuccessResponse(props.location_data.payload);

        if(props.location_data.status == "FAILED" && !fetchHotelListAttempted){
            props.getHotelListUpdatingProps();
            setFetchHotelListAttempted(true)
        }

    }, [props.location_data, fetchHotelListAttempted])


    React.useEffect(() => {
        scrollToTop();
    }, [])

    const handleOnSelectHotel = (hotelData) => {
        const redirectInfo = {
            appPath: "/checkin/id",

        }

        sessionStorage.setItem("redirectInfo", JSON.stringify(redirectInfo));

        setTimeout(() => {
            handleLocationSelect(props, hotelData, false, (status) => {
                if (!status) {
                    props.setGoHome();
                    // props.closeOrderPopUp(true, t("hotelSelector.already_selected_location"), "", false);
                }
            })
        }, 100);
    }

    return (
        <>
              
                <header className="inner-pages w-footer subpages">
                 <a className="button-back" onClick={() => props.setGoHome(true)}></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                     </div>

                </header>
                

            <section className="widgets padding-0 margin-0 loc-selector book-list">
                <div class="widget-header widget-header-checkin-inner">
                     
                </div>
              

                <div>
                     <div class="widget-header-title2">
                         <div class="heading" dangerouslySetInnerHTML={ {__html: "Find Your Stay"}}></div> 
                         <div class="subheading" >Select your hotel to check-in, and have your confirmation number ready.</div>
                    </div>
                </div>

                <div className="widgets">

                    {
                        props.location_data.status == "PENDING" ?
                            <MiniLoader />
                            : props.location_data.status == "FAILED" ?
                                <div className="hotel-selector-error" >
                                    <p>{t('hotelSelector.something_went_wrong')}</p>
                                    <button onClick={()=>{setFetchHotelListAttempted(false);}}>{t('hotelSelector.retry')}</button>
                                </div>
                                :
                                <>
                                     
                                    {
                                        hotelRegionData.length > 0 && hotelRegionData.map((hotelRegion, index) => {
                                            return (
                                                <div key={index}>
                                                    <h3>{hotelRegion.region}</h3>

                                                    {hotelRegion.hotelList.map((hotelData) => {
                                                        return (
                                                            hotelData.hotelPropertyKey != master_hotel_code && <div onClick={() => handleOnSelectHotel(hotelData)} class={`tile-selection tile-container app-link `}>
                                                                <div class="tile-selection-img">
                                                                    {hotelData.hotelBannerImageUrl ?
                                                                        <img src={hotelData.hotelBannerImageUrl}></img> :
                                                                        ""
                                                                    }
                                                                </div>
                                                                <div class="tile-selection-text">
                                                                    <div class="tile-selection-heading">{hotelData.hotelName}</div>
                                                                    <div class="tile-selection-desc">{hotelData.hotelAddress}</div>
                                                                    <div class="tile-selection-desc">{hotelData.hotelAboutInfo}</div>
                                                                </div>
                                                                {/* <img src={externalLinkSvg} /> */}
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            )
                                        })
                                    }
                                </>
                    }

                </div>
            </section>
        </>
    )
}

const getWidgetSelector = (state) => {

    var widgets = [];

    state.store.home.currentDuration.bigWidgets.map((obj) => {
        if (state.store2.currentHomePage.tabName) {
            if (obj.uniqueKey === state.store2.currentHomePage.uniqueKey
                || obj.uniqueKey === state.store2.currentHomePage.tabName.replace(/ /g, '').toLowerCase()) {
                widgets = obj.widgets
            }
        }
    })
    console.log('getWidgetSs', widgets)
    return widgets
};



const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}


const mapStateToProps = state => {
    return {
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        menuColor: state.store.home.MenuColor,
        promoWidgets: state.store.home.currentDuration.bigWidgets ? getWidgetSelector(state) : [],
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        location_data: state.store2.location_data,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
            externalSignIn: state.store2.externalSignIn,
        footerTabList: getTabs(state.store.home.currentDuration),
        widgetList: state.store2.sideNavBar.widgetList,
        externalSignIn: state.store2.externalSignIn,
    }
}

export default connect(mapStateToProps, { setGoHome, setOpenExternalLinkInSameTab, closeOrderPopUp, setLoader, setFailScreen, setHotelSelectionAfterLoginState, sendAnalytics, getHotelListUpdatingProps, setShowCustomPopup, setCurrentHomePage, setCurrentTabNavItemList, currentWidget })(withTranslation('translations')(FindStayForTheNonKnowMembers));